var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereumGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 44,
    viewBox: "0 0 28 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_692_50038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0016 0L13.6992 0.999983V30.0995L14.0016 30.3918L27.9976 22.4073L14.0016 0Z",
    fill: "#937821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.996 0L0 22.4073L13.996 30.3918V16.269V0Z",
    fill: "#D8BA5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9973 32.9465L13.8223 33.1542V43.5156L13.9973 44.0002L28.0013 24.9697L13.9973 32.9465Z",
    fill: "#937821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.996 44.0002V32.9465L0 24.9697L13.996 44.0002Z",
    fill: "#D8BA5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 30.3914L27.996 22.4069L14 16.2686V30.3914Z",
    fill: "#725D1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 22.4069L13.996 30.3914V16.2686L0 22.4069Z",
    fill: "#9A8023"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_692_50038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumGold);
export default __webpack_public_path__ + "static/media/ethereum-gold.4bd0dfaf8e9fe31ce287ede1aab467db.svg";
export { ForwardRef as ReactComponent };